<mat-progress-bar [mode]="mode"
                  [style.position]="position"
                  [style.top]="anchor == 'top' ? '0px':'initial'"
                  [style.bottom]="anchor != 'top' ? '0px':'initial'"
                  [color]="color"
                  [value]="progress"
                  [bufferValue]="buffer">
</mat-progress-bar>